import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FixMissingUserapprovalInterceptor implements HttpInterceptor {
	constructor() {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (request.url?.endsWith('/api/userstatus/')) {
			return next.handle(request).pipe(
				map(response => {
					if (response instanceof HttpResponse) {
						if (response?.body?.user) {
							if (response?.body?.userApproval === undefined) {
								response.body.userApproval = { _$todo: 'al3 needs to update backend to get this from backend.' };
							}
						}
					}
					return response;
				})
			);
		}
		return next.handle(request);
	}
}
